import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export type InlineAlertVariant = "info" | "warning";

export interface InlineAlertProps {
  variant: InlineAlertVariant;
  children: ReactNode;
  className?: string;
}

const containerClassesByVariant: Record<InlineAlertVariant, string> = {
  info: "border-l-messages-chat-bubble-sender bg-[#F0F8FF]",
  warning: "border-l-gradients-g4 bg-grey-100",
};

/**
 * InlineAlert is a reusable component for displaying inline alert messages.
 * It supports multiple variants (info, warning) and can be extended (e.g. for size adjustments) with custom `className`.
 */
export const InlineAlert: FC<InlineAlertProps> = ({
  variant,
  children,
  className,
}) => (
  <div
    className={cx(
      "flex items-center gap-2 rounded-xl border-t-0 border-r-0 border-b-0 border-l-4 border-solid px-6 py-3",
      "font-secondary text-sm leading-[140%] font-normal text-dark-800",
      containerClassesByVariant[variant],
      className
    )}
  >
    {children}
  </div>
);
